import HostInquirer from './HostInquirer'

class MenuLinks extends HostInquirer {
    static resolveLinkFromClassName(className) {
        switch (className) {
            case 'PicoManageAccount': return 'manage_account'
            case 'PicoEditProfile': return 'edit_profile'
            case 'PicoManageNewsletters': return 'manage_newsletters'
            case 'PicoManagePayment': return 'manage_payment'
            case 'PicoGift': return 'gift'
            case 'PicoRule': return 'defaultPopup'
            case 'PicoPlan': return 'defaultPopup'
            default: return null
        }
    }

    static get CLASSES() {
        return [
            'PicoManageAccount',
            'PicoEditProfile',
            'PicoManageNewsletters',
            'PicoManagePayment',
            'PicoGift',
            'PicoRule',
            'PicoPlan',
        ]
    }

    constructor(context) {
        super(context)
        this.initiated = false
        this.handlersToRegister = MenuLinks.CLASSES.map((className) => {
            const elements = this.getAllElementsFromClassName(className)
            return {
                elements,
                className,
            }
        })
    }

    // first we see what has the menu link elements on the page
    init = () => {
        if (!this.initiated) {
            this.initiated = true
            this.handlersToRegister.forEach(({ elements, className }) => {
                if (elements.length) {
                    this.registerClassCallbacks({
                        elements,
                        className,
                    })
                }
            })
        }
    }

    registerClassCallbacks = ({ elements, className }) => {
        const link = MenuLinks.resolveLinkFromClassName(className)
        const clickHandler = (e) => {
            // remove default link behavior if they add the class to an href
            e.preventDefault()
            return this.context.Pico.handleMenuLinkClick(link)
        }
        elements.forEach((element) => {
            element.addEventListener('click', clickHandler)
        })
    }
}

export default MenuLinks
